import httpClientPayments from '../api/httpClientPayments';

// Dues Policy Management
export const getCurrentDuesPolicy = async () => {
  const response = await httpClientPayments.get('/api/payments/DuesPolicyManagement/GetCurrent');
  return response.data;
};

export const updateDuesPolicy = async (payload) => {
  const response = await httpClientPayments.put('/api/payments/DuesPolicyManagement/Update', payload);
  return response.data;
};

export const getAllDuesPolicies = async () => {
  const response = await httpClientPayments.get('/api/payments/DuesPolicyManagement/GetAll');
  return response.data;
};

// Dues Management
export const createMemberDues = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/DuesManagement/CreateMemberDues', payload);
  return response.data;
};

export const startBulkCreateDues = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/DuesManagement/StartBulkCreateDues', payload);
  return response.data;
};

export const getBulkCreateDuesStatus = async (jobId) => {
  const response = await httpClientPayments.get(`/api/payments/DuesManagement/BulkCreateStatus/${jobId}`);
  return response.data;
};

export const updateDues = async (payload) => {
  const response = await httpClientPayments.put('/api/payments/DuesManagement/Update', payload);
  return response.data;
};

export const deleteDues = async (id) => {
  const response = await httpClientPayments.delete(`/api/payments/DuesManagement/Delete/${id}`);
  return response.data;
};

export const getDuesById = async (id) => {
  const response = await httpClientPayments.get(`/api/payments/DuesManagement/GetById/${id}`);
  return response.data;
};

export const getDuesByMemberId = async (memberId) => {
  const response = await httpClientPayments.get(`/api/payments/DuesManagement/GetByMemberId/Member/${memberId}`);
  return response.data;
};

export const getDuesByPeriod = async (period, status = null) => {
  const params = {};
  if (status !== null && status !== undefined) {
    params.status = status;
  }
  const response = await httpClientPayments.get(`/api/payments/DuesManagement/GetByPeriod/Period/${period}`, { params });
  return response.data;
};

export const getPaidDuesByPeriod = async (period) => {
  const response = await httpClientPayments.get(`/api/payments/DuesManagement/GetByPeriod/Period/${period}/Paid`);
  return response.data;
};

export const getUnpaidDuesByPeriod = async (period) => {
  const response = await httpClientPayments.get(`/api/payments/DuesManagement/GetByPeriod/Period/${period}/Unpaid`);
  return response.data;
};

export const getAllDues = async ({ pageNumber = 1, pageSize = 10, status = null, searchTerm = null } = {}) => {
  const params = { pageNumber, pageSize };
  if (status !== null && status !== undefined) {
    params.status = status;
  }
  if (searchTerm !== null && searchTerm !== undefined && searchTerm.trim() !== '') {
    params.searchTerm = searchTerm.trim();
  }
  const response = await httpClientPayments.get('/api/payments/DuesManagement/GetAll', { params });
  return response.data;
};

// Payment Operations
export const markAsPaidByAdmin = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/DuesManagement/MarkAsPaidByAdmin/MarkAsPaidByAdmin', payload);
  return response.data;
};

export const approvePayment = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/DuesManagement/ApprovePayment/ApprovePayment', payload);
  return response.data;
};

export const cancelDues = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/DuesManagement/Cancel/Cancel', payload);
  return response.data;
};

// Event Payment Management
export const getAllEventPayments = async ({ pageNumber = 1, pageSize = 10, startDate = null, endDate = null, status = null, payerPersonId = null, eventId = null, searchTerm = null } = {}) => {
  const params = { pageNumber, pageSize };
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (status !== null && status !== undefined) params.status = status;
  if (payerPersonId) params.payerPersonId = payerPersonId;
  if (eventId) params.eventId = eventId;
  if (searchTerm && searchTerm.trim() !== '') params.searchTerm = searchTerm.trim();
  const response = await httpClientPayments.get('/api/payments/EventPaymentManagement/GetAll', { params });
  return response.data;
};

export const getEventPaymentsByEventId = async (eventId, { status = null, payerPersonId = null } = {}) => {
  const params = {};
  if (status !== null && status !== undefined) params.status = status;
  if (payerPersonId) params.payerPersonId = payerPersonId;
  const response = await httpClientPayments.get(`/api/payments/EventPaymentManagement/GetByEventId/${eventId}`, { params });
  return response.data;
};

export const getEventPaymentsByPayer = async (payerPersonId, { status = null, startDate = null, endDate = null } = {}) => {
  const params = {};
  if (status !== null && status !== undefined) params.status = status;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const response = await httpClientPayments.get(`/api/payments/EventPaymentManagement/GetByPayer/${payerPersonId}`, { params });
  return response.data;
};

export const getEventPaymentForPayer = async (eventId, payerPersonId) => {
  const response = await httpClientPayments.get(`/api/payments/EventPaymentManagement/GetEventPaymentForPayer/${eventId}/${payerPersonId}`);
  return response.data;
};

export const cancelEventPayment = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/EventPaymentManagement/Cancel/Cancel', payload);
  return response.data;
};

export const markEventPaymentAsPaid = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/EventPaymentManagement/MarkAsPaid', payload);
  return response.data;
};

export const approveEventPayment = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/EventPaymentManagement/ApprovePayment', payload);
  return response.data;
};

export const getEventSummaries = async ({ pageNumber = 1, pageSize = 10, startDate = null, endDate = null, status = null, searchTerm = null } = {}) => {
  const params = { pageNumber, pageSize };
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (status !== null && status !== undefined) params.status = status;
  if (searchTerm && searchTerm.trim() !== '') params.searchTerm = searchTerm.trim();
  const response = await httpClientPayments.get('/api/payments/EventPaymentManagement/GetEventSummaries', { params });
  return response.data;
};

export const getEventPaymentsWithGuests = async (eventId) => {
  const response = await httpClientPayments.get(`/api/payments/EventPaymentManagement/GetEventPaymentsWithGuests/WithGuests/${eventId}`);
  return response.data;
};

export const payForGuestOrHost = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/EventPaymentManagement/PayForGuestOrHost/PayForGuestOrHost', payload);
  return response.data;
};

export const payForSelectedGuests = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/EventPaymentManagement/PayForSelectedGuests/PayForSelectedGuests', payload);
  return response.data;
};

// Donation Card Management
export const getCurrentDonationCard = async () => {
  const response = await httpClientPayments.get('/api/payments/DonationCardManagement/GetCurrent');
  return response.data;
};

export const getDonationCardById = async (id) => {
  const response = await httpClientPayments.get(`/api/payments/DonationCardManagement/GetById/${id}`);
  return response.data;
};

export const getDonationCardLogoDefaults = async () => {
  const response = await httpClientPayments.get('/api/payments/DonationCardManagement/GetLogoDefaults');
  return response.data;
};

// Bağış kartı oluşturma (görselli) - CreateDonationCardWithImageDto
export const createDonationCard = async (payload) => {
  const formData = new FormData();
  const { description, amount, currency, isActive, logoIncomeArpCode, imageFile } = payload;

  if (description) formData.append('Description', description);
  if (amount !== undefined && amount !== null) formData.append('Amount', String(amount));
  if (currency) formData.append('Currency', currency);
  if (typeof isActive === 'boolean') formData.append('IsActive', String(isActive));
  if (logoIncomeArpCode !== undefined) {
    formData.append('LogoIncomeArpCode', logoIncomeArpCode ?? '');
  }
  if (imageFile instanceof File) {
    formData.append('ImageFile', imageFile, imageFile.name);
  }

  const response = await httpClientPayments.post(
    '/api/payments/DonationCardManagement/Create',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

// Bağış kartı güncelleme (metinsel alanlar) - UpdateDonationCardDto
export const updateDonationCard = async (payload) => {
  const response = await httpClientPayments.put('/api/payments/DonationCardManagement/Update', payload);
  return response.data;
};

// Bağış kartı görselini ayrı endpoint ile güncelleme
export const uploadDonationCardImage = async ({ cardId, file }) => {
  const formData = new FormData();
  if (file instanceof File) {
    formData.append('file', file, file.name);
  }

  const response = await httpClientPayments.post(
    `/api/payments/DonationCardManagement/UploadImage?cardId=${encodeURIComponent(cardId)}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

// Donation Card Purchase Management
export const getAllDonationCardPurchases = async ({ pageNumber = 1, pageSize = 10, status = null, purchasedByPersonId = null, donatedToPersonId = null, searchTerm = null } = {}) => {
  const params = { pageNumber, pageSize };
  if (status !== null && status !== undefined) params.status = status;
  if (purchasedByPersonId) params.purchasedByPersonId = purchasedByPersonId;
  if (donatedToPersonId) params.donatedToPersonId = donatedToPersonId;
  if (searchTerm && searchTerm.trim() !== '') params.searchTerm = searchTerm.trim();
  const response = await httpClientPayments.get('/api/payments/DonationCardPurchaseManagement/GetAll', { params });
  return response.data;
};

export const getDonationCardPurchaseById = async (id) => {
  const response = await httpClientPayments.get(`/api/payments/DonationCardPurchaseManagement/GetById/${id}`);
  return response.data;
};

export const getDonationCardPurchasesByPurchasedBy = async (personId, type) => {
  const params = { personId, type };
  const response = await httpClientPayments.get('/api/payments/DonationCardPurchaseManagement/GetByPurchasedBy', { params });
  return response.data;
};

export const getDonationCardPurchasesByDonatedTo = async (personId, type) => {
  const params = { personId, type };
  const response = await httpClientPayments.get('/api/payments/DonationCardPurchaseManagement/GetByDonatedTo', { params });
  return response.data;
};

export const approveDonationCardPayment = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/DonationCardPurchaseManagement/ApprovePayment', payload);
  return response.data;
};

export const cancelDonationCardPurchase = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/DonationCardPurchaseManagement/Cancel', payload);
  return response.data;
};

export const createDonationCardPurchase = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/DonationCardPurchaseManagement/Create', payload);
  return response.data;
};

export const searchDonationCardPurchases = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/DonationCardPurchaseManagement/Search/Search', payload);
  return response.data;
};

export const getTopDonors = async ({ topCount = 10, startDate = null, endDate = null } = {}) => {
  const params = { topCount };
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const response = await httpClientPayments.get('/api/payments/DonationCardPurchaseManagement/GetTopDonors/TopDonors', { params });
  return response.data;
};

export const getTopRecipients = async ({ topCount = 10, startDate = null, endDate = null } = {}) => {
  const params = { topCount };
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const response = await httpClientPayments.get('/api/payments/DonationCardPurchaseManagement/GetTopRecipients/TopRecipients', { params });
  return response.data;
};

export const getDonationCardPurchasesByMemberIdPurchased = async (memberId, { pageNumber = 1, pageSize = 10 } = {}) => {
  const params = { memberId, pageNumber, pageSize };
  const response = await httpClientPayments.get('/api/payments/DonationCardPurchaseManagement/GetByMemberIdPurchased/ByMemberIdPurchased', { params });
  return response.data;
};

export const getDonationCardPurchasesByMemberIdDonatedTo = async (memberId, { pageNumber = 1, pageSize = 10 } = {}) => {
  const params = { memberId, pageNumber, pageSize };
  const response = await httpClientPayments.get('/api/payments/DonationCardPurchaseManagement/GetByMemberIdDonatedTo/ByMemberIdDonatedTo', { params });
  return response.data;
};

export const getDonationStatistics = async ({ startDate = null, endDate = null } = {}) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const response = await httpClientPayments.get('/api/payments/DonationCardPurchaseManagement/GetStatistics/Statistics', { params });
  return response.data;
};

// Project Donation Management
export const getAllProjectDonations = async ({
  pageNumber = 1,
  pageSize = 10,
  projectId = null,
  status = null,
  payerPersonId = null,
  searchTerm = null,
} = {}) => {
  const params = { pageNumber, pageSize };
  if (projectId) params.projectId = projectId;
  if (status !== null && status !== undefined) params.status = status;
  if (payerPersonId) params.payerPersonId = payerPersonId;
  if (searchTerm && searchTerm.trim() !== '') params.searchTerm = searchTerm.trim();
  const response = await httpClientPayments.get('/api/payments/ProjectDonationManagement/GetAll', { params });
  return response.data;
};

export const getProjectDonationById = async (id) => {
  const response = await httpClientPayments.get(`/api/payments/ProjectDonationManagement/GetById/${id}`);
  return response.data;
};

export const getProjectDonationsByProjectId = async ({
  projectId,
  pageNumber = 1,
  pageSize = 10,
  status = null,
} = {}) => {
  const params = { projectId, pageNumber, pageSize };
  if (status !== null && status !== undefined) params.status = status;
  const response = await httpClientPayments.get('/api/payments/ProjectDonationManagement/GetAllByProjectId/ByProjectId', { params });
  return response.data;
};

export const searchProjectDonations = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/ProjectDonationManagement/Search/Search', payload);
  return response.data;
};

export const createProjectDonationByAdmin = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/ProjectDonationManagement/Create', payload);
  return response.data;
};

export const approveProjectDonationPayment = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/ProjectDonationManagement/ApprovePayment/ApprovePayment', payload);
  return response.data;
};

export const cancelProjectDonation = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/ProjectDonationManagement/Cancel/Cancel', payload);
  return response.data;
};

export const getProjectDonationStatistics = async ({ startDate = null, endDate = null } = {}) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const response = await httpClientPayments.get('/api/payments/ProjectDonationManagement/GetStatistics/Statistics', { params });
  return response.data;
};

export const getProjectDonationSummaryByProject = async ({ startDate = null, endDate = null } = {}) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const response = await httpClientPayments.get('/api/payments/ProjectDonationManagement/GetSummaryByProject/SummaryByProject', { params });
  return response.data;
};

// Product Management
export const getAllProducts = async ({ search = null, category = null, isActive = null } = {}) => {
  const params = {};
  if (search && search.trim() !== '') params.search = search.trim();
  if (category && category.trim() !== '') params.category = category.trim();
  if (isActive !== null && isActive !== undefined) params.isActive = isActive;
  const response = await httpClientPayments.get('/api/payments/ProductManagement/GetAll', { params });
  return response.data;
};

export const getProductById = async (id) => {
  const response = await httpClientPayments.get(`/api/payments/ProductManagement/GetById/${id}`);
  return response.data;
};

export const getProductLogoDefaults = async () => {
  const response = await httpClientPayments.get('/api/payments/ProductManagement/GetLogoDefaults');
  return response.data;
};

export const createProduct = async (payload) => {
  const formData = new FormData();
  const {
    name,
    description,
    category,
    price,
    currency,
    stockQuantity,
    order,
    maxQuantityPerOrder,
    isActive,
    logoIncomeArpCode,
    imageFile,
  } = payload;

  if (name) formData.append('Name', name);
  if (description) formData.append('Description', description);
  if (category) formData.append('Category', category);
  if (price !== undefined && price !== null) formData.append('Price', String(price));
  if (currency) formData.append('Currency', currency);
  if (stockQuantity !== undefined && stockQuantity !== null)
    formData.append('StockQuantity', String(stockQuantity));
  if (order !== undefined && order !== null) formData.append('Order', String(order));
  if (maxQuantityPerOrder !== undefined && maxQuantityPerOrder !== null)
    formData.append('MaxQuantityPerOrder', String(maxQuantityPerOrder));
  if (typeof isActive === 'boolean') formData.append('IsActive', String(isActive));
  if (logoIncomeArpCode !== undefined) {
    formData.append('LogoIncomeArpCode', logoIncomeArpCode ?? '');
  }
  if (imageFile instanceof File) {
    formData.append('ImageFile', imageFile, imageFile.name);
  }

  const response = await httpClientPayments.post(
    '/api/payments/ProductManagement/Create',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

export const updateProduct = async (payload) => {
  const response = await httpClientPayments.put('/api/payments/ProductManagement/Update', payload);
  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await httpClientPayments.delete(`/api/payments/ProductManagement/Delete/${id}`);
  return response.data;
};

export const updateProductStock = async ({ productId, deltaQuantity }) => {
  const response = await httpClientPayments.post(
    '/api/payments/ProductManagement/UpdateStock/UpdateStock',
    null,
    { params: { productId, deltaQuantity } }
  );
  return response.data;
};

export const setProductStock = async ({ productId, newQuantity }) => {
  const response = await httpClientPayments.post(
    '/api/payments/ProductManagement/SetStock/SetStock',
    null,
    { params: { productId, newQuantity } }
  );
  return response.data;
};

export const reorderProducts = async (items) => {
  const response = await httpClientPayments.post('/api/payments/ProductManagement/Reorder', items);
  return response.data;
};

export const uploadProductImage = async ({ productId, file }) => {
  const formData = new FormData();
  if (file instanceof File) {
    formData.append('file', file, file.name);
  }
  const response = await httpClientPayments.post(
    `/api/payments/ProductManagement/UploadImage?productId=${encodeURIComponent(productId)}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

// Product Order Management (ürün siparişleri / satışları)
export const getAllProductOrders = async ({
  pageNumber = 1,
  pageSize = 10,
  status = null,
  productId = null,
  buyerPersonId = null,
  startDate = null,
  endDate = null,
} = {}) => {
  const params = { pageNumber, pageSize };
  if (status !== null && status !== undefined) params.status = status;
  if (productId) params.productId = productId;
  if (buyerPersonId) params.buyerPersonId = buyerPersonId;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const response = await httpClientPayments.get('/api/payments/ProductOrderManagement/GetAll', { params });
  return response.data;
};

export const getProductOrderById = async (id) => {
  const response = await httpClientPayments.get(`/api/payments/ProductOrderManagement/GetById/${id}`);
  return response.data;
};

export const createProductOrder = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/ProductOrderManagement/Create', payload);
  return response.data;
};

export const cancelProductOrder = async (payload) => {
  const response = await httpClientPayments.post('/api/payments/ProductOrderManagement/Cancel', payload);
  return response.data;
};

export default {
  getCurrentDuesPolicy,
  updateDuesPolicy,
  getAllDuesPolicies,
  createMemberDues,
  startBulkCreateDues,
  getBulkCreateDuesStatus,
  updateDues,
  deleteDues,
  getDuesById,
  getDuesByMemberId,
  getDuesByPeriod,
  getPaidDuesByPeriod,
  getUnpaidDuesByPeriod,
  getAllDues,
  markAsPaidByAdmin,
  approvePayment,
  cancelDues,
  getAllEventPayments,
  getEventPaymentsByEventId,
  getEventPaymentsByPayer,
  getEventPaymentForPayer,
  cancelEventPayment,
  markEventPaymentAsPaid,
  approveEventPayment,
  getEventSummaries,
  getEventPaymentsWithGuests,
  payForGuestOrHost,
  payForSelectedGuests,
  getCurrentDonationCard,
  getDonationCardById,
  getDonationCardLogoDefaults,
  createDonationCard,
  updateDonationCard,
  uploadDonationCardImage,
  getAllDonationCardPurchases,
  getDonationCardPurchaseById,
  getDonationCardPurchasesByPurchasedBy,
  getDonationCardPurchasesByDonatedTo,
  getDonationCardPurchasesByMemberIdPurchased,
  getDonationCardPurchasesByMemberIdDonatedTo,
  approveDonationCardPayment,
  cancelDonationCardPurchase,
  createDonationCardPurchase,
  searchDonationCardPurchases,
  getTopDonors,
  getTopRecipients,
  getDonationStatistics,
  getAllProjectDonations,
  getProjectDonationById,
  getProjectDonationsByProjectId,
  searchProjectDonations,
  createProjectDonationByAdmin,
  approveProjectDonationPayment,
  cancelProjectDonation,
  getProjectDonationStatistics,
  getProjectDonationSummaryByProject,
  getAllProducts,
  getProductById,
  getProductLogoDefaults,
  createProduct,
  updateProduct,
  deleteProduct,
  updateProductStock,
  setProductStock,
  reorderProducts,
  uploadProductImage,
  getAllProductOrders,
  getProductOrderById,
  createProductOrder,
  cancelProductOrder,
};
